import gql from 'graphql-tag';

import { getCurrentUserId } from '../../../common/utils';

const queryFields = `
  commentId
  parentId
  content
  metadata
  assetIds
  resourceId
  shotId
  sceneId
  viewers {
    userId
    firstName
    lastName
    email
    imageUrl
  }
  isResolved
  updatedAt
  createdByUser {
    userId
    firstName
    lastName
    email
    imageUrl
  }
  children {
    commentId
    parentId
    content
    metadata
    assetIds
    isResolved
    shotId
    sceneId
    updatedAt
    createdByUser {
      userId
      firstName
      lastName
      email
      imageUrl
    }
  }`;

export const getCommentsQuery = () => gql`
  query getComments($resourceId: String!, $versionIds:[String], $filters: Filters) {
    getComments(resourceId: $resourceId, versionIds: $versionIds, filters: $filters) {
      ${queryFields}
    }
  }
`;

export const getPublicCommentsQuery = () => gql`
  query getPublicComments($resourceId: String!, $versionIds:[String]) {
    getPublicComments(resourceId: $resourceId, versionIds: $versionIds) {
      ${queryFields}
    }
  }
`;

const getComments = () => ({
  query: getCurrentUserId() ? getCommentsQuery() : getPublicCommentsQuery(),
  module: 'comments',
  ignoreCache: true,
  buildVariables: ({
    resourceId,
    versionIds,
    filters




  }) => ({
    resourceId,
    versionIds,
    filters
  })
});

export default getComments;